import * as $ from "jquery"

const init = ()=> {

	const select = $('select')

   if(select.length > 0 ){

		select.each( (i,e)  => {
			const ele = $(e)
			const parent = $(e).parent();
			parent.css('position','relative')
			parent.append(`<i class="ico-chevron-down"></i>`)
		});
   }

}

export const forms = {
	init: init
};